import { PerspectiveCameraProps, useThree } from "@react-three/fiber";
import { useLayoutEffect } from "react";

interface AspectRatioProps {
  camera: PerspectiveCameraProps;
}

export const AspectRatio = ({ camera }: AspectRatioProps) => {
  const viewport = useThree((state) => state.viewport);
  useLayoutEffect(() => {
    if (!camera) return;

    camera.aspect = viewport.width / viewport.height;
    camera.updateProjectionMatrix();
  }, [viewport, camera]);

  return null;
};
